const dict = {
    chat: {
      open: '打开农业助手',
      close: '关闭对话',
      title: '田园智士助手',
      subtitle: '随时聊聊种植问题',
      conversation: '对话记录',
      welcome: '从一个问题开始',
      intro: '可以询问作物管理、土壤养分或病虫害防治，也可以上传叶片、果实照片让我帮你看看。',
      exampleQuestion: '番茄叶片发黄，应该先检查什么？',
      suggestionSoil: '土壤偏酸，种蔬菜前该怎么改良？',
      suggestionPest: '玉米出现蚜虫，有哪些低毒防治方法？',
      copy: '复制回答',
      copied: '已复制',
      retry: '重试',
      stop: '停止生成',
      thinking: '正在思考…',
      autoRead: '自动朗读',
      autoReadOn: '自动朗读已开启，点击关闭',
      autoReadOff: '自动朗读已关闭，点击开启',
      speak: '朗读',
      stopSpeaking: '停止朗读',
      speechFailed: '朗读失败，请稍后重试',
      speechNotConfigured: '语音朗读尚未配置',
      sources: '来源',
      newChat: '新对话',
      attachImage: '添加图片',
      removeImage: '移除图片',
      imageAlt: '用户上传的图片',
      imageLimit: '最多添加 4 张图片',
      imageUnsupported: '无法读取这张图片，请换一张 JPG 或 PNG 图片',
      imageTooLarge: '图片过大，请换一张较小的图片',
      dropHint: '松开即可添加图片',
      placeholder: '输入你的问题…',
      send: '发送消息',
      notConfigured: '模型尚未配置。请在系统设置中启用 Gemini 并填写 API Key。',
      rateLimited: '发送过于频繁，请稍后再试。',
      requestFailed: '暂时无法获取回复，请重试。',
    },
    ttsSettings: {
      title: '语音朗读（TTS）',
      description: '配置阿里云百炼 DashScope 语音合成，农业助手的回复可一键朗读。API Key 保存后不会再显示。',
      loading: '正在加载…',
      loadFailed: '无法加载语音朗读配置，请稍后重试',
      sessionExpired: '登录已过期，请退出后重新登录再配置',
      adminRequired: '仅管理员可以配置语音朗读',
      enabled: '启用语音朗读',
      url: 'WebSocket 地址',
      urlHint: '仅支持 wss:// 开头的阿里云地址（*.aliyuncs.com）',
      model: '模型',
      voice: '音色',
      voicePlaceholder: '例如 longanli_v3.1',
      voiceHint: '音色须与模型匹配。列表中是适合问答助手的系统音色；需要其它系统音色或复刻音色时选「自定义音色」。',
      voiceSelect: '选择音色',
      groupAssistant: '语音助手',
      groupService: '客服与旁白',
      groupDialect: '方言与多语种',
      customVoice: '自定义音色…',
      customVoiceLabel: '自定义音色 ID',
      voiceDocs: '查看官方完整音色列表',
      voices: {
        longanli: 'Long An Li · 女 · 干练高效',
        longanwen: 'Long An Wen · 女 · 优雅知性',
        longanlang: 'Long An Lang · 男 · 清爽利落',
        longxiaoxia: 'Long Xiaoxia · 女 · 沉稳权威',
        baiqinglan: 'Bai Qinglan · 女 · 明亮年轻',
        yezhiqing: 'Ye Zhiqing · 女 · 轻快自然',
        yeqinghe: 'Ye Qinghe · 女 · 亲切温柔',
        longyingtao: 'Long Yingtao · 女 · 温和沉稳',
        anmingyuan: 'An Mingyuan · 男 · 清晰自然',
        huozhuoshi: 'Huo Zhuoshi · 男 · 清晰',
        longanhuan: 'Long An Huan · 女 · 支持方言与多语种',
        xunanchuan: 'Xu Nanchuan · 男 · 支持方言与多语种',
      },
      apiKey: 'DashScope API Key',
      apiKeyKeep: '已设置，留空则保持不变',
      apiKeyEmpty: '尚未设置',
      save: '保存语音设置',
      saved: '语音朗读设置已保存',
      saveFailed: '保存失败',
    },
    aiLoading: {
      statuses: {
        composing: 'AI 正在生成方案中',
        validating: 'AI 正在进行最后验证',
      },
      processing: '实时处理中',
      completed: '已完成',
      waiting: '等待中',
      note: '请保持页面开启，分析完成后将自动展示结果',
      recommendation: {
        desc: '正在连接多源农业数据库，综合土壤、气候、市场与风险信息生成推荐方案。',
        channels: {
          c1: '土壤参数建模',
          c2: '气候条件推演',
          c3: '农业知识检索',
          c4: '市场趋势分析',
        },
      },
      yield: {
        desc: '正在综合土壤养分、气象条件与历史产量数据，测算本季产量区间与优化空间。',
        channels: {
          c1: '土壤养分解析',
          c2: '气象条件推演',
          c3: '历史产量比对',
          c4: '产量模型测算',
        },
      },
      price: {
        desc: '正在归集历史行情、供需与季节性因素，生成价格走势与区间预测。',
        channels: {
          c1: '历史价格归集',
          c2: '供需季节分析',
          c3: '价格模型测算',
          c4: '走势区间生成',
        },
      },
      disease: {
        desc: '正在对图像进行预处理与特征提取，比对病害图谱并生成防治建议。',
        channels: { c1: '图像预处理', c2: '病斑特征提取', c3: '病害图谱比对', c4: '防治方案生成' },
      },
      calendar: {
        desc: '正在匹配品种物候与本地气候窗口，编排全周期农事节点与管理要点。',
        channels: {
          c1: '品种物候匹配',
          c2: '气候窗口推演',
          c3: '农事节点编排',
          c4: '管理要点生成',
        },
      },
    },
    brand: '田园智士',
    header: {
      nav: {
        home: '首页',
        recommendation: '作物推荐',
        yield: '产量预测',
        disease: '病害识别',
        price: '价格预测',
        calendar: '农事日历',
      },
      auth: {
        login: '登录',
        logout: '退出登录',
        admin: '管理员',
        systemMonitor: '控制面板',
      },
      lang: '语言',
    },
    hero: {
      titleLeading: '数据驱动',
      titleEmphasis: '未来农业',
      desc: '利用先进的人工智能技术，我们为您提供精准的作物推荐、产量预测与病虫害识别，助力您的每一次丰收。',
      btns: {
        recommendation: '智能作物推荐',
        disease: 'AI病害识别',
      },
      kpis: {
        accuracy: 'AI识别准确率',
        crops: '支持作物种类',
      },
      panel: {
        eyebrow: '田块诊断 · 实时',
        status: '分析完成',
        fieldsTitle: '土壤与气候',
        fields: [
          { label: '氮含量 (N)', value: '62 kg/亩' },
          { label: '磷含量 (P)', value: '38 kg/亩' },
          { label: '钾含量 (K)', value: '45 kg/亩' },
          { label: 'pH 值', value: '6.8' },
          { label: '年均温度', value: '24 ℃' },
          { label: '年降雨量', value: '1450 mm' },
        ],
        resultTitle: '推荐作物',
        crops: [
          { name: '水稻', confidence: 96 },
          { name: '玉米', confidence: 89 },
          { name: '大豆', confidence: 84 },
        ],
      },
    },
    stats: {
      accuracy: 'AI识别准确率',
      crops: '支持作物种类',
      regions: '主要农业地区覆盖',
      realtime: '实时数据更新',
    },
    features: {
      title: '一站式智能农业解决方案',
      subtitle: '从播种到收获，我们为您提供全方位的智能决策支持。',
      detail: '了解详情 →',
      items: {
        recommendation: {
          title: '智能作物推荐',
          desc: '根据土壤、气候和市场数据，为您推荐最具经济效益的作物品种。',
        },
        yield: {
          title: '精准产量预测',
          desc: '结合多维度数据，科学预测作物产量，帮助您提前规划，规避风险。',
        },
        disease: {
          title: 'AI病害识别',
          desc: '只需上传照片，即可快速识别作物病害，并获取专业的防治建议。',
        },
        price: {
          title: '市场价格预测',
          desc: '分析历史价格与市场趋势，科学预测未来价格，助您把握最佳销售时机。',
        },
        calendar: {
          title: '智能农事日历',
          desc: '自动生成全生长周期的农事安排，让您轻松管理，不错过任何关键节点。',
        },
      },
    },
    how: {
      title: '三步轻松上手',
      steps: {
        provide: {
          title: '提供数据',
          desc: '输入您的种植环境、土壤状况等基本信息。',
        },
        analyze: {
          title: '云端分析',
          desc: '我们强大的AI模型将对您的数据进行深度分析和计算。',
        },
        plan: {
          title: '获取方案',
          desc: '即时获取为您量身定制的科学种植决策方案。',
        },
      },
    },
    cta: {
      title: '准备好迎接您的下一次大丰收了吗？',
      subtitle: '选择适合您的智能农业工具，立即开始科学种植。',
      cards: {
        recommendation: {
          title: '作物推荐',
          desc: '基于您的土壤和气候条件',
          btn: '立即开始',
        },
        price: {
          title: '价格预测',
          desc: '掌握市场趋势，把握最佳时机',
          btn: '查看价格',
        },
        disease: {
          title: '病害识别',
          desc: '拍照即可识别病害问题',
          btn: '拍照识别',
        },
      },
    },
    pain: {
      title: '我们如何为您解决农业难题',
      subtitle: '直面农业生产中的核心挑战，我们提供数据驱动的智能解决方案。',
      imageAlt: '农户在田间仔细查看作物长势',
      faqs: [
        {
          q: '不知道种什么最赚钱？',
          a: '我们的作物推荐系统结合土壤、气候和市场数据，为您推荐当前最具经济效益的作物品种。',
        },
        {
          q: '担心收成不好，心里没底？',
          a: '通过产量预测功能，科学预估作物产量，帮助您提前规划，规避市场风险。',
        },
        {
          q: '作物生病了，不知如何是好？',
          a: 'AI病害识别功能，只需上传照片，即可快速识别病害并获得专业防治建议。',
        },
        {
          q: '成本收益算不清，盲目投入风险高？',
          a: '成本计算器帮您精细化管理财务，清晰掌握投入与产出，让每一分钱都花在刀刃上。',
        },
      ],
    },
    footer: {
      productTitle: '农业智能预测平台',
      productDesc: '基于人工智能和数据科学的智能农业系统，帮助农民科学决策，优化农业生产。',
      quickLinks: '快速链接',
      contact: '联系我们',
      email: '邮箱',
      phone: '电话',
      address: '地址',
      rights: '保留所有权利。',
    },
    common: { loadingPage: '页面加载中...', unknownCrop: '未知作物' },
    login: {
      product: '智能农业预测平台',
      subtitle: '输入用户名和密码登录您的账户',
      usernameLabel: '用户名',
      usernamePlaceholder: '请输入用户名',
      passwordLabel: '密码',
      passwordPlaceholder: '请输入密码',
      submit: '登录',
      submitting: '登录中...',
      errorInvalid: '用户名或密码错误',
      errorFailed: '登录失败，请稍后重试',
      slogan: '智能农业 • 科技助农 • 精准预测',
      noAccount: '没有账号？',
      registerLink: '注册',
    },
    register: {
      subtitle: '创建您的智能农业账号',
      usernameLabel: '用户名',
      usernamePlaceholder: '请输入用户名（至少3个字符）',
      nameLabel: '姓名',
      namePlaceholder: '请输入您的真实姓名',
      emailLabel: '邮箱',
      emailPlaceholder: '请输入邮箱地址',
      phoneLabel: '手机号',
      phonePlaceholder: '请输入手机号（可选）',
      passwordLabel: '密码',
      passwordPlaceholder: '请输入密码（至少6个字符）',
      confirmPasswordLabel: '确认密码',
      confirmPasswordPlaceholder: '请再次输入密码',
      submit: '注册',
      submitting: '注册中...',
      success: '注册成功！正在自动登录...',
      errorPasswordShort: '密码至少需要6个字符',
      errorPasswordMismatch: '两次输入的密码不一致',
      errorEmailInvalid: '请输入有效的邮箱地址',
      errorFailed: '注册失败，请稍后重试',
      hasAccount: '已有账号？',
      loginLink: '登录',
      registrationDisabled: '管理员已关闭注册功能，如需注册请联系管理员',
      backToLogin: '返回登录',
    },
    systemMonitor: {
      title: '系统监控台',
      subtitle: '实时监控外部API调用和通知系统状态',
      lastUpdate: '最后更新',
      refreshManual: '手动刷新',
      refreshing: '刷新中...',
      metrics: {
        total: '总通知数',
        unread: '未读通知',
        dataIn: '数据接收',
        dataInSub: '作物/病害数据',
        status: '系统状态',
        running: '运行中',
        serverOk: '服务器正常',
      },
      tabs: { recent: '最近通知', types: '按类型统计', test: 'API测试' },
      recent: {
        title: '最近的通知记录',
        clearAll: '清空所有通知',
        empty: '暂无通知记录',
        hint: '使用外部工具调用API来测试通知系统',
        badgeUnread: '未读',
        fieldId: 'ID',
        fieldTime: '时间',
        typeCrop: '作物推荐',
        typeDisease: '病害识别',
      },
      test: {
        apiTitle: 'API端点测试',
        cropTitle: '作物推荐数据接收API',
        cropDesc: '使用Postman或curl向此端点发送数据即可测试通知功能',
        diseaseTitle: '病害识别图片接收API',
        diseaseDesc: '发送base64图片数据到此端点',
        explainTitle: '测试说明',
        supportedTitle: '现在支持的功能:',
        supportedList: [
          '• 外部API调用自动创建服务器端通知',
          '• 浏览器实时轮询获取新通知（5秒间隔）',
          '• 通知点击跳转并自动填充数据',
          '• 支持已读/未读状态同步',
        ],
        realtimeTitle: '实时更新:',
        realtimeDesc: '本页面每3秒自动刷新，通知中心每5秒检查新通知',
        stepsTitle: '测试步骤:',
        stepsList: [
          '1. 打开Postman或其他API工具',
          '2. 发送POST请求到API端点',
          '3. 在此页面观察通知记录增加',
          '4. 在右上角通知中心查看新通知',
          '5. 点击通知测试跳转功能',
        ],
      },
    },
    notificationImport: {
      title: '通知导入工具',
      subtitle: '将Postman或其他API测试工具的响应数据导入为通知',
      importCardTitle: '导入API响应数据',
      label: '粘贴API响应JSON数据',
      fillSample: '填入示例数据',
      placeholder: '粘贴完整的API响应JSON数据到这里...',
      importBtn: '导入通知',
      result: {
        successLabel: '成功',
        errorLabel: '错误',
        addedHint: '通知已添加到通知中心，点击右上角的铃铛图标查看',
      },
      messages: {
        successImportedPrefix: '通知已导入: ',
        localStorageFailed: '保存通知到localStorage失败',
        invalidFormat: '无效的通知数据格式，请确保包含notification字段或是完整的通知对象',
        parseFailedPrefix: 'JSON解析失败: ',
        unknownError: '未知错误',
      },
      help: {
        title: '使用说明',
        supportedTitle: '支持的数据格式：',
        supportedList: [
          '• 完整的API响应（包含 notification 字段）',
          '• 单独的通知对象（包含 id、title、message 等字段）',
        ],
        stepsTitle: '使用步骤：',
        stepsList: [
          '1. 在Postman中调用API（如 /api/receive-crop-data）',
          '2. 复制完整的响应JSON数据',
          '3. 粘贴到上面的文本框中',
          '4. 点击"导入通知"按钮',
          '5. 查看右上角通知中心的新通知',
        ],
        quickCopy: {
          title: '快速复制',
          desc: '在Postman中，点击响应区域右上角的复制按钮，然后粘贴到这里即可',
        },
      },
    },
    recommendation: {
      title: '作物推荐系统',
      subtitle: '根据您的土壤条件和气候环境，科学推荐最适合种植的作物',
      cardTitle: '输入土壤和气候条件',
      cardDesc: '请填写以下参数或上传检测报告，我们将根据这些数据为您推荐最适合的作物种类',
      tabs: { manual: '手动输入', upload: '上传报告' },
      sections: {
        soil: { title: '土壤养分与酸碱度', desc: '来自土壤检测报告的核心指标' },
        climate: { title: '气候与降水条件', desc: '地块所在区域的气候数据' },
      },
      sidebar: {
        referenceTitle: '参数参考范围',
        referenceHint: '自动校验',
        tipTitle: '没有检测报告？',
        tipText: '先用示例数据体验一次完整的推荐流程，再替换成您的真实数据。',
      },
      fields: {
        nitrogenLabel: '氮含量 (N) (kg/亩)',
        nitrogenHint: '土壤中的氮含量，一般在0-100 kg/亩之间',
        phosphorusLabel: '磷含量 (P) (kg/亩)',
        phosphorusHint: '土壤中的磷含量，一般在0-100 kg/亩之间',
        potassiumLabel: '钾含量 (K) (kg/亩)',
        potassiumHint: '土壤中的钾含量，一般在0-100 kg/亩之间',
        temperatureLabel: '年均温度 (℃)',
        temperatureHint: '地区年平均温度，一般在-10-50 ℃之间',
        humidityLabel: '湿度 (%)',
        humidityHint: '空气湿度，范围在0-100%之间',
        phLabel: 'pH值',
        phHint: '土壤pH值，范围在0-14之间',
        rainfallLabel: '年降雨量 (mm)',
        rainfallHint: '地区年降雨量，一般在0-5000 mm之间',
      },
      actions: { sample: '使用示例数据', reset: '重置数据', submit: '开始推荐' },
      upload: {
        dropHere: '拖拽文件到此处，或点击上传',
        support: '支持 .csv, .json 格式',
        browse: '选择文件',
        clear: '移除文件',
        viewParsed: '查看解析结果',
      },
    },
    diseaseDetection: {
      title: '病虫害识别与防治',
      subtitle: '上传您作物的照片，我们将智能识别病虫害并提供防治建议',
      cardTitle: '图片上传',
      cardDesc: '请上传清晰的作物照片，确保病害部位清楚可见',
      dropHere: '拖拽图片到此处，或点击上传',
      support: '支持 .jpg, .png, .jpeg 等图片格式',
      analyzing: '分析中...',
      preparing: '正在处理图片…',
      startDetect: '开始识别',
      prepareError: {
        title: '图片处理失败',
        desc: '图片压缩或暂存失败，请重新选择图片后再试一次。',
      },
      resultsPage: {
        pageTitle: 'AI 病害识别结果',
        pageSubtitle: '基于上传图片的智能病虫害诊断与防治建议',
        backToUpload: '返回重新上传',
        diagnosedImageAlt: '待诊断的作物图片',
        empty: {
          title: '请先上传图片',
          desc: '未检测到待识别的图片，可能是刷新了页面或直接访问了此链接。请返回上传页面重新选择一张作物照片。',
          action: '返回上传图片',
        },
      },
      result: {
        titlePrefix: '识别结果:',
        unrecognized: {
          title: '图片识别失败',
          tip: '上传的图片不是植物或无法识别植物内容。请确保图片清晰显示植物的叶片、茎杆或其他部位，然后重新尝试。',
          aiFeedbackPrefix: 'AI反馈：',
        },
        description: '病害描述',
        identifiedCrop: '识别作物',
        diseaseCategory: '病害类别',
        emergency: '紧急行动建议',
        symptoms: '主要症状',
        treatment: '治疗方案',
        prevention: '预防措施',
        seasonal: '季节性管理建议',
        important: '重要提醒',
        importantText:
          '以上识别结果仅供参考，建议结合实际情况和专业农技人员的建议进行综合判断和处理。如病情严重，请及时联系当地农技部门。',
        retry: '重新识别',
      },
      error: {
        title: '识别失败',
        unavailableTitle: 'AI 模型未配置',
        unavailableHint: '请前往「控制面板 → 系统设置 → 模型」完成大模型配置后重试。',
        failedHint: '请稍后重试。',
        retry: '重试',
        goToSettings: '前往系统设置',
      },
    },
    recommendationResults: {
      actions: { back: '返回输入', rerun: '重新推荐', download: '下载报告' },
      loading: {
        title: 'AI正在分析您的数据...',
        desc: '正在连接多源农业数据库，综合土壤、气候、市场与风险信息生成推荐方案。',
        statuses: {
          thinking: 'AI 正在思考中',
          searching: 'AI 正在从网上搜索结果中',
          modeling: 'AI 正在交叉验证候选作物',
          composing: 'AI 正在生成方案中',
          validating: 'AI 正在进行最后验证',
        },
        channels: {
          soil: '土壤参数建模',
          climate: '气候条件推演',
          knowledge: '农业知识检索',
          market: '市场趋势分析',
        },
        processing: '实时处理中',
        completed: '已完成',
        waiting: '等待中',
        note: '请保持页面开启，分析完成后将自动展示结果',
      },
      error: {
        title: '获取推荐失败',
        hint: '请检查网络连接后重试，或稍后再试',
        unavailableTitle: 'AI 模型未配置',
        unavailableHint: '请前往「控制面板 → 系统设置 → 模型」完成大模型配置后重试',
        retry: '重试',
        goToSettings: '前往系统设置',
      },
      empty: { title: '暂无推荐结果', desc: '根据您提供的参数，暂时无法生成推荐方案' },
      degraded: {
        notice: '部分内容为降级占位',
        affected: '受影响区块',
        hint: '系统已返回安全占位数据，请稍后重试以获取完整分析。',
      },
      page: { title: '智能推荐结果', subtitle: '基于您提供的土壤和气候数据的综合分析' },
      tabs: {
        overview: '总览',
        analysis: '数据分析',
        economics: '经济分析',
        risks: '风险评估',
        guidance: '种植指导',
      },
      overview: {
        inputSummary: '输入参数摘要',
        metrics: {
          nitrogen: '氮含量',
          phosphorus: '磷含量',
          potassium: '钾含量',
          temperature: '年均温度',
          humidity: '湿度',
          ph: 'pH值',
          rainfall: '年降雨量',
        },
        highlight: {
          best: '最佳推荐',
          core: '核心指标',
          expectedYield: '预期产量',
          growthPeriod: '生长周期',
          marketPrice: '市场价格',
          profitMargin: '利润率',
          growInfo: '种植信息',
          plantingTime: '播种时间',
          harvestTime: '收获时间',
          soilType: '土壤类型',
          riskLevel: '风险等级',
          reasons: '推荐理由',
          allTitle: '所有推荐作物',
          recommendedBadge: '推荐',
          suitability: '适配度',
          confidence: '置信度',
        },
        aiSuggestions: {
          title: 'AI智能推荐作物',
          confidence: '置信度',
          keyPoints: '重点提示',
          noData: '暂无AI推荐结果，请稍后重试',
        },
      },
      analysis: {
        yieldReportTitlePrefix: 'AI产量预测分析报告 - ',
        yieldSummary: '预测总结',
        min: '最低产量',
        opt: '最优产量',
        max: '最高产量',
        keyFactors: '关键影响因子',
        optimization: '优化建议',
        confidence: '分析置信度',
        reliability: '数据可靠性',
        noYieldData: '暂无产量分析数据',
        loading: 'AI正在分析产量预测...',
        loadingEconomics: 'AI正在分析经济效益...',
        failPrefix: '产量分析生成失败: ',
        fallbackBasic: '将显示基础产量信息',
        basicInfoTitle: '基础产量信息',
      },
      charts: {
        suitabilityComparison: '综合适配度对比',
        suitabilityAxis: '综合适配度(%)',
        envAdapt: '环境适应性分析',
        radarName: '适应性',
        nutrition: '营养需求对比',
        current: '当前含量',
        required: '推荐含量',
        marketPrice: '市场价格信息',
        marketIntegrated: '价格信息已整合在推荐结果中',
        currentMarketPricePrefix: '当前市场价格: ',
        noSuitabilityData: '暂无综合适配度数据',
        noAdaptabilityData: '暂无环境适应性数据',
        noNutritionData: '暂无营养需求对比数据',
      },
      economics: {
        title: '经济效益分析',
        expectedIncome: '预期收入',
        plantingCost: '种植成本',
        netProfit: '净利润',
        roi: '投资回报率',
        profitability: '盈利能力分析',
        marketOutlook: '市场前景',
        costBreakdown: '成本构成分析',
        total: '总计',
        wait: '经济分析数据需要AI生成，请等待分析结果...',
        failPrefix: '经济分析生成失败: ',
        fallbackBasic: '将显示基础经济信息',
        basicInfoTitle: '基础经济信息',
      },
      risks: {
        title: '风险评估',
        overall: '整体风险等级',
        table: { type: '风险类型', level: '风险等级', probability: '可能性', impact: '影响程度' },
        summaryTitle: '风险评估总结',
        recommendations: '风险管理建议',
        wait: '风险评估数据需要AI生成，请等待分析结果...',
      },
      guidance: {
        titlePrefix: '种植技术指导',
        keyPoints: '关键技术要点',
        generating: 'AI正在生成详细的种植技术指导...',
        wait: '种植指导数据需要AI生成，请等待分析结果...',
        loading: 'AI正在生成种植指导...',
      },
      labels: {
        kpi: '监测KPI',
        stage: '阶段',
        cost: '成本',
        yieldChange: '产量变化',
        tradeoff: '权衡',
        prerequisites: '前置条件',
      },
      adaptability: {
        temperature: '温度',
        water: '水分',
        soil: '土壤',
        climate: '气候',
        market: '市场',
      },
      nutrients: { N: '氮(N)', P: '磷(P)', K: '钾(K)' },
    },
    pricePrediction: {
      title: '市场价格预测',
      subtitle: '查看作物的历史价格走势，并获取未来市场价格的科学预测',
      guide: {
        title: '使用指南',
        steps: {
          selectCrop: { title: '选择作物', desc: '从下拉菜单中选择您关心的作物类型' },
          selectRegion: { title: '选择地区', desc: '可选择特定地区获取更精准的价格信息' },
          seeTrend: { title: '查看走势', desc: '分析历史价格和未来6个月预测' },
          makeStrategy: { title: '制定策略', desc: '根据分析结果制定买卖策略' },
        },
      },
      selection: {
        title: '选择作物',
        desc: '选择您想要查看价格预测的作物类型',
        hint: '支持75种作物的价格分析',
        cropLabel: '选择作物',
        regionLabel: '选择地区',
        cropPlaceholder: '请选择作物',
        regionPlaceholder: '请选择地区',
        nationalMarket: '全国市场',
        submit: '开始预测',
      },
      loading: {
        analyzing: '正在分析价格数据...',
        bulletFetch: '• 获取最新市场价格信息',
        bulletHistory: '• 分析历史价格趋势',
        bulletPredict: '• 计算未来6个月预测',
        bulletRisk: '• 评估市场风险因素',
      },
      chart: {
        title: '价格走势图 (元/公斤)',
        descSuffix: '的历史价格和未来预测',
        clickHint: '点击图表可查看详细数据',
        legend: '价格走势（蓝色实线：历史 | 绿色标记：预测）',
        tooltip: { datePrefix: '日期:', predicted: '预测价格', historical: '历史价格' },
      },
      details: { title: '详细价格数据', predicted: '预测', historical: '历史' },
      analysis: {
        summaryTitle: '分析摘要',
        confidence: '置信度',
        priceChangeTitle: '价格变化预测',
        currentPrice: '当前价格',
        predicted6m: '6个月预测',
        expectedChange: '预期变化',
        factors: '影响因素',
        adviceTitle: '投资建议',
        supplyDemandTitle: '供需分析',
        currentSupply: '当前供应',
        demandTrend: '需求趋势',
        inventoryLevel: '库存水平',
        balance: '供需平衡',
        priceAlertTitlePrefix: '价格预警 - ',
        actionAdvicePrefix: '建议行动：',
        regionsCompareTitle: '地区价格对比',
        detailedMarketTitle: '详细市场分析',
        seasonalTitle: '季节性因素',
        risksTitle: '风险评估',
        noticeTitle: '重要提醒',
        noticeText:
          '价格预测基于历史数据和市场分析，仅供参考。实际价格可能受到突发事件、政策变化、自然灾害等多种因素影响。投资决策请谨慎考虑，建议结合多方信息综合判断。',
      },
      start: {
        title: '开始价格分析',
        desc: '请选择一种作物以查看其价格分析和预测',
        featuresTitle: '功能特色',
        features: [
          '• AI驱动的价格预测',
          '• 详细的供需分析',
          '• 智能价格预警系统',
          '• 多地区价格对比',
        ],
      },
      regions: {
        all: '全国市场',
        north: '华北地区（北京、天津、河北、山西、内蒙古）',
        northeast: '东北地区（辽宁、吉林、黑龙江）',
        east: '华东地区（上海、江苏、浙江、安徽、福建、江西、山东）',
        south: '华南地区（广东、广西、海南）',
        southwest: '西南地区（重庆、四川、贵州、云南、西藏）',
        northwest: '西北地区（陕西、甘肃、青海、宁夏、新疆）',
        central: '华中地区（河南、湖北、湖南）',
        jjj: '京津冀城市群',
        yzj: '长三角地区',
        zsj: '珠三角地区',
        cy: '成渝经济圈',
      },
    },
    calendar: {
      title: '农事日历与提醒',
      subtitle: '选择作物和种植日期，自动生成全生长周期的农事安排',
      form: {
        cardTitle: 'AI智能农事日历',
        cardDesc: '选择作物和地区，AI将根据当前天气、季节等因素生成个性化农事计划',
        cropLabel: '选择作物',
        regionLabel: '选择地区',
        dateLabel: '选择种植/播种日期 (可选)',
        datePlaceholder: '不选择则默认使用今天',
        dateHint: ' 不选择种植日期将默认使用今天作为种植日期',
        btnGenerate: '生成智能农事日历',
        btnGenerating: 'AI生成中...',
      },
      info: {
        plantingOverview: '种植信息概览',
        crop: '作物',
        region: '地区',
        plantingDate: '种植日期',
        growthPeriod: '生长周期',
        harvest: '预计收获',
        suitability: '适合度',
        climateAnalysis: '气候分析',
      },
      ai: {
        adviceTitle: 'AI专业建议',
        seasonalTips: '季节性提示',
        weatherRisks: '天气风险',
        localRecommendations: '当地建议',
        dataSourcePrefix: ' 数据来源:',
      },
      timeline: {
        title: 'AI智能农事时间线',
        descPrefix: '根据当前天气、季节、地理位置等因素为',
        descSuffix: '智能生成的农事安排',
        datePrefix: '',
        daysAfterPrefix: ' 播种后第',
        daysAfterSuffix: '天',
      },
      tips: {
        title: '温馨提示',
        list: [
          '• 以上时间安排仅供参考，请根据当地气候条件和实际情况调整',
          '• 建议提前3-5天准备相关农资和工具',
          '• 遇到恶劣天气时，可适当推迟农事活动',
          '• 定期观察作物生长状况，及时调整管理措施',
        ],
      },
      emptyPrompt: '请选择作物类型和种植日期，生成个性化的农事日历',
      regions: {
        north: '华北地区',
        northeast: '东北地区',
        east: '华东地区',
        south: '华南地区',
        southwest: '西南地区',
        northwest: '西北地区',
        central: '华中地区',
      },
    },
    yieldResults: {
      loading: {
        title: 'AI正在分析产量预测...',
        desc: '请稍候，我们正在为您生成个性化的产量预测分析',
      },
      actions: { backToInput: '返回输入', rePredict: '重新预测' },
      pageTitle: '产量预测分析报告',
      pageSubtitle: '基于AI模型的智能农业产量预测与分析',
      tabs: {
        overview: '概览',
        factors: '影响因子',
        recommendations: '建议优化',
        sensitivity: '灵敏度与诊断',
      },
      inputSummary: { title: '输入参数摘要' },
      metrics: {
        temperature: '年均温度',
        rainfall: '年降雨量',
        ph: 'pH值',
        nitrogen: '氮含量',
        phosphorus: '磷含量',
      },
      main: {
        predictedYield: '预测产量',
        expectedIncome: '预期收益',
        localEstimate: '（本地估算）',
        confidence: '置信度',
      },
      level: { excellent: '优秀', good: '良好', fair: '一般', low: '偏低' },
      risk: {
        low: '低风险',
        medium: '中等风险',
        high: '高风险',
        unknown: '未知',
        title: '风险评估',
        overall: '总体风险等级',
        climate: '气候风险',
        soil: '土壤风险',
        nutrient: '营养风险',
        levelHigh: '较高',
        levelLow: '较低',
        levelMedium: '中等',
      },
      comparison: {
        yieldTitle: '产量对比分析',
        economicTitle: '经济效益对比',
        summaryTitle: '综合建议',
      },
      env: { title: '环境适应性分析', details: '环境因子详情' },
      recommend: { title: '优化建议' },
      planting: {
        title: '种植时间建议',
        bestSowing: '最佳播种期',
        keyMgmt: '关键管理期',
        harvest: '收获时间',
      },
      economic: {
        title: '经济效益分析',
        totalIncome: '预期总收益/亩',
        estimatedCost: '预估成本/亩',
        netProfit: '预期净利润/亩',
      },
      sensitivity: {
        title: '参数灵敏度分析',
        impactLabel: '影响',
        explain:
          '说明：为避免与其他模块重复，这里采用基于输入的启发式近似，快速判断对产量的相对影响强弱，用于参数调优方向提示。',
      },
      dataQuality: {
        title: '输入数据质量诊断',
        rangeCheck: '数值范围检查',
        consistency: '一致性/异常值提示',
      },
      chartSeries: { predicted: '预测产量', base: '基准产量', economicValue: '经济价值' },
      envFactors: {
        tempAdapt: '温度适应性',
        rainAdapt: '降雨适应性',
        phAdapt: 'pH适应性',
        nutrientUse: '营养利用率',
        pestResistance: '病虫害抗性',
      },
      ai: {
        summaryTitle: 'AI 总体判断',
        dataReliabilityLabel: '数据可靠性',
        rangeLabel: '预测区间',
        factorsTitle: 'AI 因子分析',
        suggestionCategoryFallback: '优化建议',
        labels: {
          stage: '适用阶段',
          cost: '成本',
          yieldChange: '产量变化',
          tradeoff: '权衡',
          kpi: '关键指标',
          prerequisites: '前置条件',
          benefit: '预期收益',
        },
        riskTitle: 'AI 风险评估',
        riskOverall: '综合风险等级',
        riskTable: { type: '风险类型', level: '等级', probability: '发生概率', impact: '影响说明' },
        riskSummaryTitle: '风险总结',
        riskRecommendationsTitle: '应对建议',
        guidanceTitle: 'AI 种植指导',
        guidanceKeyPoints: '关键要点',
      },
    },
    yield: {
      crops: {
        rice: ' 水稻',
        corn: ' 玉米',
        wheat: ' 小麦',
        potato: ' 马铃薯',
        cotton: ' 棉花',
        sugarcane: ' 甘蔗',
        soybean: ' 大豆',
        tomato: ' 番茄',
        cucumber: ' 黄瓜',
        apple: ' 苹果',
        grape: ' 葡萄',
        peanut: ' 花生',
        rapeseed: ' 油菜',
        watermelon: ' 西瓜',
        pepper: ' 辣椒',
        eggplant: ' 茄子',
        cabbage: ' 甘蓝',
        carrot: ' 胡萝卜',
        strawberry: ' 草莓',
        tea: ' 茶',
        coffee: ' 咖啡',
        banana: ' 香蕉',
        blackbean: ' 黑豆',
        jute: ' 黄麻',
        coconut: ' 椰子',
        papaya: ' 木瓜',
        melon: ' 甜瓜',
        kidneybeans: ' 芸豆',
        mungbean: ' 绿豆',
        orange: ' 橙子',
        chickpea: ' 鹰嘴豆',
        lentil: ' 小扁豆',
        mothbeans: ' 蛾豆',
        pigeonpeas: ' 木豆',
        mango: ' 芒果',
        pomegranate: ' 石榴',
      },
      form: {
        title: '农作物产量预测系统',
        subtitle: '根据土壤条件和气候环境，科学预测作物产量',
        cardTitle: '产量预测参数输入',
        cardDesc: '请选择作物类型并填写相关参数，我们将为您预测作物产量',
        cropSectionDesc: '选择主要预测作物，可添加第二种作物进行横向对比',
        cropPrimaryHint: '作为本次产量预测的主要分析对象',
        cropComparisonHint: '可选，用于生成同条件下的产量对比',
        environmentSectionDesc: '填写两种作物共用的土壤、气候与农事投入数据',
        referenceTitle: '参数参考',
        referenceHint: '建议范围',
        tipTitle: '快速体验',
        tipText: '不确定如何填写？载入一组完整示例数据，快速查看预测流程。',
        crop1Label: '作物一 (用于对比)',
        crop1Placeholder: '请选择作物一',
        crop2Label: '作物二 (可选, 用于对比)',
        crop2Placeholder: '不选择',
        crop2None: '不选择',
        sharedTitle: '共享环境参数',
        nitrogenLabel: '氮含量 (N) (kg/亩)',
        nitrogenHint: '土壤中的氮含量，一般在0-100 kg/亩之间',
        phosphorusLabel: '磷含量 (P) (kg/亩)',
        phosphorusHint: '土壤中的磷含量，一般在0-100 kg/亩之间',
        potassiumLabel: '钾含量 (K) (kg/亩)',
        potassiumHint: '土壤中的钾含量，一般在0-100 kg/亩之间',
        temperatureLabel: '年均温度 (℃)',
        temperatureHint: '地区年平均温度，一般在-10-50 ℃之间',
        humidityLabel: '湿度 (%)',
        humidityHint: '空气湿度，范围在0-100%之间',
        phLabel: 'pH值',
        phHint: '土壤pH值，范围在3-10之间',
        rainfallLabel: '年降雨量 (mm)',
        rainfallHint: '地区年降雨量，一般在200-4000 mm之间',
        pesticideLabel: '农药用量 (kg/ha)',
        pesticideHint: '每公顷农药使用量，一般在0-100 kg/ha之间',
        btnSample: '使用示例数据',
        btnReset: '重置数据',
        btnStart: '开始预测',
      },
    },
}

export default dict
